import { render, staticRenderFns } from "./Shy.vue?vue&type=template&id=09f52862&scoped=true"
import script from "./Shy.vue?vue&type=script&lang=js"
export * from "./Shy.vue?vue&type=script&lang=js"
import style0 from "./Shy.vue?vue&type=style&index=0&id=09f52862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f52862",
  null
  
)

export default component.exports